import axios from "axios";

import {
  config,
  CUSTOM_API_ROOT_PROD_PLATFORM,
  CUSTOM_API_ROOT_TEST_PLATFORM,
} from "../config";

import { session } from "./session";

export const httpPlatform = axios.create({
  baseURL:
    window.location.hostname.includes("krupa-snab-test") ||
    window.location.hostname.includes("localhost")
      ? CUSTOM_API_ROOT_TEST_PLATFORM
      : CUSTOM_API_ROOT_PROD_PLATFORM,
});

httpPlatform.interceptors.request.use((request) => {
  const token = session.get();

  if (token) {
    request.headers = {
      ...request.headers,
      [config.backendTokenKEY]: `Bearer ${token}`,
    };
  }

  return request;
});
